/**
 * Models for push notification subscription
 */

export interface PushSubscriptionKeys {
  p256dh: string;
  auth: string;
}

export interface PushSubscriptionRequest {
  endpoint: string;
  keys: PushSubscriptionKeys;
  deviceId?: string;
}

export interface PushUnsubscribeRequest {
  endpoint: string;
}

export interface PushSubscriptionResponse {
  success: boolean;
  message: string;
  error?: string;
}

export interface NotificationPayload {
  title: string;
  body: string;
  icon?: string;
  badge?: string;
  data?: any;
  actions?: NotificationAction[];
}

export interface NotificationAction {
  action: string;
  title: string;
  icon?: string;
}

export interface VapidPublicKeyViewModel {
  publicKey: string;
}
